<template>
  <main class="main cus_internet_mobile_create" role="main" v-if="isCompleted">
    <div class="main_con">
      <div class="m_con">
        <div class="m_title_img">
          <img
            src="@/assets/front/images/mobile/img_phone_start_n.svg"
            alt=""
          />
        </div>
        <div class="m_title_txt">
          퍼스의 휴대폰 견적 받기는 이렇게 진행돼요!
        </div>
        <div class="m_step_info">
          <div class="m_step_txt">
            <div class="txt_list_wrap">
              <div class="point on"></div>
              <div class="txt_list">
                <div class="title_txt on">1. 견적요청</div>
                <div class="txt">견적을 받기 위해 몇 가지 질문에 답하기!</div>
              </div>
            </div>
            <div class="txt_list_wrap">
              <div class="point"></div>
              <div class="txt_list">
                <div class="title_txt">2. 견적수신</div>
                <div class="txt">매장에서 보낸 견적을 확인하고 비교하기!</div>
              </div>
            </div>
            <div class="txt_list_wrap">
              <div class="point"></div>
              <div class="txt_list">
                <div class="title_txt">3. 상담진행</div>
                <div class="txt">맘에 드는 매장과 채팅 상담 시작하기!</div>
              </div>
            </div>
            <div class="txt_list_wrap">
              <div class="point last"></div>
              <div class="txt_list">
                <div class="title_txt">4. 가입신청</div>
                <div class="txt">
                  상담이 만족스러웠다면 개통을 위한 가입신청서 작성 및 접수하기!
                </div>
              </div>
            </div>
            <div class="bar"></div>
          </div>
        </div>
        <div class="m_step_info_2">
          <div class="img_1">
            <img src="@/assets/front/images/v2/etc/imoji_search.png" />
          </div>
          <div class="txt_1">
            휴대폰 개통 후 견적 내용과 개통 내용이 일치하는지
            <span class="rd">반드시 확인</span>하시기 바랍니다!
          </div>
        </div>
      </div>
    </div>
    <div class="btm_btn">
      <div class="btn_wrap" @click="showMobileNotice">
        <button class="btn" :disabled="disabled">
          시작하기
        </button>
      </div>
    </div>
    <DesignPopup2
      :show="designPopup"
      :data="{
        title: '견적 받아보기 안내',
        type: 'alert',
        msg: `휴대폰 견적 받아보기는 <br /> 일주일에 3회까지만 가능합니다.`,
      }"
      @close="popupClose"
    />
    <MobileNoticePopup
      :show="isShowMobileNotice"
      @close="closeMobileNotice"
      @agree="MobileNoticeAgree"
    />
  </main>
</template>
<script>
import DesignPopup2 from '@/common/components/modal/DesignPopup2';
import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';

import format from 'date-fns/format';

import {
  checkMobileOperatingSystem,
  setCallbackOnClickBackKey,
  nativeEnableBackKey,
  nativeDisableBackKey,
} from '@common/lib/common/utils';

import MobileNoticePopup from '@/common/components/modal/MobileNoticePopup.vue';

export default {
  name: 'mobile_create',
  components: {
    DesignPopup2,
    MobileNoticePopup,
  },
  data() {
    return {
      isCompleted: false,
      isMode: '', // 휴대폰스펙찾기 : MY_MOBILE, default : ''
      designPopup: false,
      disabled: true,
      isShowMobileNotice: false,
    };
  },
  async created() {
    this.isMode = this.$route.query.mode;
    this.isCompleted = true;
    await this.goMobileCreate();
  },
  // mounted() {
  // },
  computed: {
    ...mobileMapGetters({
      mobileRequestListIng: mobileTypes.MOBILE_REQUEST_LIST_ING,
      mobileRequestListEnd: mobileTypes.MOBILE_REQUEST_LIST_END,
    }),
  },
  methods: {
    ...mobileMapActions([
      mobileTypes.SELECT_MOBILE_REQUEST_LIST_ING,
      mobileTypes.SELECT_MOBILE_REQUEST_LIST_END,
    ]),
    gotoEstimate() {
      this.$router.push({
        name: 'Mobile.RequestForm',
        query: {
          mode: this.isMode,
        },
      });
    },
    async goMobileCreate() {
      nativeEnableBackKey();
      let params = {
        callPart: 'CUSTOMER',
        status: 'ING',
        page: 1,
        size: 3,
      };
      await this[mobileTypes.SELECT_MOBILE_REQUEST_LIST_ING](params);

      console.log(params);

      console.log('mobileRequestListIng');
      console.log(this.mobileRequestListIng);

      let paramsEnd = {
        callPart: 'CUSTOMER',
        status: 'END',
        page: 1,
        size: 3,
      };
      await this[mobileTypes.SELECT_MOBILE_REQUEST_LIST_END](paramsEnd);

      console.log(paramsEnd);

      console.log('mobileRequestListEnd');
      console.log(this.mobileRequestListEnd);

      let goCreateCheck = true;
      const now = format(new Date(), 'yyyy-MM-dd HH:mm:ss');

      if (this.mobileRequestListIng.content.length >= 3) {
        goCreateCheck = false;
      } else if (this.mobileRequestListIng.content.length == 2) {
        if (this.mobileRequestListEnd.content.length > 0) {
          const requestedAt = new Date(
            this.mobileRequestListEnd.content[0].requestedAt,
          );

          const sDays = format(
            new Date(requestedAt.setDate(requestedAt.getDate() + 7)),
            'yyyy-MM-dd HH:mm:ss',
          );

          // 안지났음
          if (now < sDays) {
            goCreateCheck = false;
          } else {
            goCreateCheck = true;
          }
        } else {
          goCreateCheck = true;
        }
      } else if (this.mobileRequestListIng.content.length == 1) {
        if (this.mobileRequestListEnd.content.length > 1) {
          const requestedAt_1 = new Date(
            this.mobileRequestListEnd.content[0].requestedAt,
          );

          const sDays_1 = format(
            new Date(requestedAt_1.setDate(requestedAt_1.getDate() + 7)),
            'yyyy-MM-dd HH:mm:ss',
          );

          const requestedAt_2 = new Date(
            this.mobileRequestListEnd.content[1].requestedAt,
          );

          const sDays_2 = format(
            new Date(requestedAt_2.setDate(requestedAt_2.getDate() + 7)),
            'yyyy-MM-dd HH:mm:ss',
          );

          // alert('sDays_1 =' + sDays_1 + 'sDays_2 =' + sDays_2 + 'now =' + now);

          // 둘다 안지남
          if (now < sDays_1 && now < sDays_2) {
            goCreateCheck = false;
          } else {
            goCreateCheck = true;
          }
        } else {
          goCreateCheck = true;
        }
      } else if (this.mobileRequestListIng.content.length == 0) {
        if (this.mobileRequestListEnd.content.length > 2) {
          const requestedAt_1 = new Date(
            this.mobileRequestListEnd.content[0].requestedAt,
          );

          const sDays_1 = format(
            new Date(requestedAt_1.setDate(requestedAt_1.getDate() + 7)),
            'yyyy-MM-dd HH:mm:ss',
          );

          const requestedAt_2 = new Date(
            this.mobileRequestListEnd.content[1].requestedAt,
          );

          const sDays_2 = format(
            new Date(requestedAt_2.setDate(requestedAt_2.getDate() + 7)),
            'yyyy-MM-dd HH:mm:ss',
          );

          const requestedAt_3 = new Date(
            this.mobileRequestListEnd.content[2].requestedAt,
          );

          const sDays_3 = format(
            new Date(requestedAt_3.setDate(requestedAt_3.getDate() + 7)),
            'yyyy-MM-dd HH:mm:ss',
          );

          // 셋다 안지남
          if (now < sDays_1 && now < sDays_2 && now < sDays_3) {
            goCreateCheck = false;
          } else {
            goCreateCheck = true;
          }
        } else {
          goCreateCheck = true;
        }
      } else {
        goCreateCheck = true;
      }

      if (!goCreateCheck) {
        this.designPopup = true;
        this.disabled = true;
        // if (this.isMode == 'MY_MOBILE') {
        //   this.$router.go(-1);
        // } else {
        //   this.$router.push({ path: '/' }).catch(err => {});
        // }
      } else {
        this.disabled = false;
      }
    },
    popupClose() {
      this.designPopup = false;
      this.$router.go(-1);
    },
    showMobileNotice() {
      this.isShowMobileNotice = true;
    },
    closeMobileNotice() {
      this.isShowMobileNotice = false;
    },
    MobileNoticeAgree() {
      this.isShowMobileNotice = false;
      this.gotoEstimate();
    },
  },
};
</script>
